import {
    Box,
    FormControl,
    FormLabel,
    Stack,
    Text,
    Switch,
    HStack,
} from '@chakra-ui/react';
import { Field } from 'formik';
import { useState } from 'react';

import FieldError from 'components/forms/new/FieldError';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import {
    descriptionStyling,
    formLabelStyling,
    stackSpacing,
    stackStyling,
} from 'components/forms/new/formStyles';

const TRSRegistrationActiveField = ({
    errors,
    values,
    touched,
    darkMode,
    isDisabled = false,
}) => {
    const [isHovered, setIsHovered] = useState(false);

    return (
        <FormControl
            sx={{
                margin: '0 !important',
                '& svg': {
                    mt: '8px!important',
                },
            }}
            isInvalid={!!errors.isEnabled && touched.isEnabled}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack
                direction="row"
                spacing={stackSpacing}
                sx={stackStyling(true)}>
                <Box>
                    <FormLabel sx={formLabelStyling(darkMode)}>
                        Active
                    </FormLabel>
                    <Text
                        sx={{
                            ...descriptionStyling,
                            color: darkMode ? 'gray.100' : '#757575',
                        }}
                        maxW={250}>
                        Enable or disable this registration
                    </Text>
                </Box>
                <Field name="isEnabled">
                    {({ field, form: { setFieldValue } }) => (
                        <Box
                            flex="1"
                            sx={{
                                paddingTop: '15px',
                                display: 'flex',
                                alignItems: 'center',
                            }}>
                            <HStack spacing={3} alignItems="center">
                                <Switch
                                    {...field}
                                    id="isEnabled"
                                    isChecked={values?.isEnabled || false}
                                    isDisabled={isDisabled}
                                    onChange={(e) => {
                                        setFieldValue(
                                            'isEnabled',
                                            e.target.checked,
                                        );
                                    }}
                                    size="md"
                                />
                                <Text
                                    fontSize="sm"
                                    className="!mb-2"
                                    color={darkMode ? 'gray.100' : 'gray.700'}
                                    fontWeight="semibold">
                                    {values?.isEnabled ? 'Enabled' : 'Disabled'}
                                </Text>
                            </HStack>
                        </Box>
                    )}
                </Field>

                {isHovered && (
                    <FieldToolTip
                        label="Enable this registration to allow it to be used for TRS services. Disabled registrations will not be available for use."
                        ariaLabel="active-tip"
                        left="25px"
                        top="25px"
                    />
                )}
            </Stack>
            <FieldError
                error={errors?.isEnabled}
                touched={touched?.isEnabled}
            />
        </FormControl>
    );
};

export default TRSRegistrationActiveField;
